<template>
	<fragment>
		<common-header
			subname="권한 관리"
			name="권한 편집"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			:searchbox="false"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav">
				&nbsp;
			</nav>

			<div class="container-fiuld clearfix">
				<!-- <div class="btn-group-box b-b m-b-30 clearfix">
					<div class="pull-right m-b-15 clearfix">
						<button class="btn bg-deepblue text-white round w140">안내</button>
					</div>
				</div> -->

				<div class="cat_item v-top w400">
					<h3>관리자권한</h3>
					<table class="full-width table-condensed text-center">
						<vue-draggable v-model="adminAuth" tag="tbody"
							handle=".handle" v-bind="dragOptions"  @end="dragEnd('관리자', $event)">
							<tr v-for="(auth, idx) in adminAuth" :key="`admin-auth-${hash(auth)}`">
								<td>
									<a class="attr-color" :style="auth.color ? `background: ${ auth.color }` : ''">색상</a>
								</td>
								<td>{{auth.authName}}</td>
								<th>
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" @click="clickModifyAuth('관리자', idx)">수정</a>
									<a class="del" @click="deleteAuth('관리자', idx)">삭제</a>
								</th>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<a class="attr-color"  @click="$modal.show('admin-color-picker')"
										:style="adminInput.color ? `background: ${ adminInput.color }` : ''">색상</a>
								</td>
								<td>
									<input class="inline form-control-sm m-b-0 w180 v-mid round" v-model="adminInput.authName"
										type="text" placeholder="권한명 입력">
									<button class="btn-sm bg-deepblue text-white round"
										type="button" @click="addAdminAuth">추가</button>
									<button class="btn-sm bg-deepblue text-white round"
										type="button" @click="modifyAdminAuth" v-if="adminModify != null">수정</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="cat_item v-top w400">
					<h3>강사권한</h3>
					<table class="full-width table-condensed text-center">
						<vue-draggable v-model="instAuth" tag="tbody"
							handle=".handle" v-bind="dragOptions" @end="dragEnd('강사', $event)">
							<tr v-for="(auth, idx) in instAuth" :key="`inst-auth-${hash(auth)}`">
								<td>
									<a class="attr-color" :style="auth.color ? `background: ${ auth.color }` : ''">색상</a>
								</td>
								<td>{{auth.authName}}</td>
								<th>
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" @click="clickModifyAuth('강사', idx)">수정</a>
									<a class="del" @click="deleteAuth('강사', idx)">삭제</a>
								</th>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<a class="attr-color"  @click="$modal.show('inst-color-picker')"
										:style="instInput.color ? `background: ${ instInput.color }` : ''">색상</a>
								</td>
								<td>
									<input class="inline form-control-sm m-b-0 w180 v-mid round"  v-model="instInput.authName"
									type="text" placeholder="권한명 입력">
									<button class="btn-sm bg-deepblue text-white round"
										type="button" @click="addInstAuth">추가</button>
									<button class="btn-sm bg-deepblue text-white round"
										type="button" @click="modifyInstAuth" v-if="instModify != null">수정</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		<modal-confirm :config="modals.ModalConfirm" :key="hash(modals.ModalConfirm)" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" :key="hash(modals.ModalAlert)" @close="modals.ModalAlert.show=false"></modal-alert>
		<modal name="admin-color-picker" :adaptive="true" height="192">
			<div class="custom-ui-class">
				<vue-swatches v-model="adminInput.color" @input="$modal.hide('admin-color-picker')" inline></vue-swatches>
			</div>
		</modal>"
		<modal name="inst-color-picker" :adaptive="true" height="192">
			<div class="custom-ui-class">
				<vue-swatches v-model="instInput.color" @input="$modal.hide('inst-color-picker')" inline></vue-swatches>
			</div>
		</modal>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import Axios from 'axios'
import VueDraggable from 'vuedraggable'
import VueSwatches from 'vue-swatches'
// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.min.css"

import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import server from '../statics/server.js';

export default {
	// 컴포넌트 명칭
	name: "ViewPermissionList",
	mixins: [fnAdjustHeight],
	// 컴포넌트 시작시 호출되는 함수
	mounted: function() {
		this.getAuthData();
	},
	// 이 컴포넌트에서 사용할 자식 컴포넌트
	components: {
		CommonHeader,
		CommonFooter,
		VueDraggable,
		ModalAlert,
		ModalConfirm,
		VueSwatches
	},

	// 이 컴포넌트에서 내부적으로 사용 할 데이터
	data: function() {
		return {
			modals: {
				ModalAlert: ModalAlert.default(),
				ModalConfirm: ModalConfirm.default()
			},
			menus: [ // 서브메뉴
				{name:'권한 관리',link:"/permissions",selected:false},
				{name:'권한 편집',link:"/permissions/list",selected:true},
			],
			buttons: [], // 헤더버튼,
			adminAuth: [],
			instAuth: [],
			adminInput: {
				type: "관리자",
				authName: "",
				color: ""
			},
			instInput: {
				type: "강사",
				authName: "",
				color: ""
			},
			adminModify: null,
			instModify: null
		}
	},

	// 이 컴포넌트에서 내부적으로 사용 할 데이터
	methods: {
		getAuthData: async function() {
			try {
				const { data: adminData } = await Axios.post(server.addr() + server.api.AUTH, { type: "관리자" });
				const { data: instData } = await Axios.post(server.addr() + server.api.AUTH, { type: "강사" });

				this.adminAuth = adminData.list;
				this.instAuth = instData.list;
			} catch(e) {
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		dragEnd: async function(type, $event) {
			const { newIndex } = $event;
			let authList;
			switch (type) {
				case "관리자": authList = this.adminAuth; break;
				case "강사": authList = this.instAuth; break;
			}

			const targetAuth = authList[newIndex];
			let dst = 0;
			if(newIndex) {
				dst = authList[newIndex - 1].authId;
			}

			try {
				await Axios.patch(`${server.addr()}${server.api.AUTH}/${targetAuth.authId}`, { dst });
			} catch(e) {
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		addAdminAuth: async function() {
			try {
				await Axios.put(`${server.addr()}${server.api.AUTH}`, [this.adminInput]);
				this.adminInput = { type: "관리자", authName: "", color: "" }
				this.getAuthData();
			} catch(e) {
				e;
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		addInstAuth: async function() {
			try {
				await Axios.put(`${server.addr()}${server.api.AUTH}`, [this.instInput]);
				this.instInput = { type: "강사", authName: "", color: "" };
				this.getAuthData();
			} catch(e) {
				e;
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		deleteAuth: function(type, idx) {
			let targetAuth;
			switch (type) {
				case "관리자": targetAuth = this.adminAuth[idx]; break;
				case "강사": targetAuth = this.instAuth[idx]; break;
			}

			this.modals.ModalConfirm.msg="정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.fn = async () => {
				this.modals.ModalConfirm.show = false;
				try {
					await Axios.delete(`${server.addr()}${server.api.AUTH}/${targetAuth.authId}`);
					this.getAuthData();
				} catch(e) {
					e;
					this.modals.ModalAlert.msg = "서버 오류입니다.";
					this.modals.ModalAlert.show = true;
				}
			}
			this.modals.ModalConfirm.show = true;
		},
		clickModifyAuth: async function(type, idx) {
			switch(type) {
				case "관리자":
					this.adminModify = idx;
					this.adminInput = {
						color: this.adminAuth[idx].color,
						authName: this.adminAuth[idx].authName,
						type: "관리자"
					}
					break;
				case "강사":
					this.instModify = idx;
					this.instInput = {
						color: this.instAuth[idx].color,
						authName: this.instAuth[idx].authName,
						type: "강사"
					}
					break;
			}
		},
		modifyAdminAuth: async function() {
			const target = this.adminAuth[this.adminModify];
			try {
				await Axios.patch(`${server.addr()}${server.api.AUTH}/${target.authId}`, this.adminInput);
				this.adminInput = { type: "관리자", authName: "", color: "" };
				this.getAuthData(); 
				this.adminModify = null;
			} catch(e) {
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		modifyInstAuth: async function() {
			const target = this.instAuth[this.instModify];
			try {
				await Axios.patch(`${server.addr()}${server.api.AUTH}/${target.authId}`, this.instInput);
				this.instInput = { type: "강사", authName: "", color: "" };
				this.getAuthData();
				this.instModify = null;
			} catch(e) {
				this.modals.ModalAlert.msg = "서버 오류입니다.";
				this.modals.ModalAlert.show = true;
			}
		}
	},
	computed: {
		dragOptions() {
			return {
				ghostClass: "ghost"
			}
		}
	}
}
</script>